<template>
  <b-row>
    <template v-if="tempGlobalPalletDoc.visible == false">
      <b-col>
        <v-btn color="blue darken-1" text @click="addService">
          <v-icon dark>mdi-plus</v-icon>
          {{ $t("ADD") }} {{ $t("PALLET") }}
        </v-btn>
      </b-col>
    </template>
    <template v-if="tempGlobalPalletDoc.visible == true">
      <b-col :sm="12">
        <v-btn color="red darken-1" text @click="removeService">
          <v-icon dark>mdi-minus</v-icon>
          {{ $t("REMOVE") }}
          {{ $t("PALLET") }}
        </v-btn>
        <h3>{{ $t("PALLET") }}:</h3>
      </b-col>
      <b-col lg="3">
        <v-text-field
          :disabled="true"
          v-model="supplierName"
          :label="$t('SUPPLIER')"
          hide-details
        ></v-text-field>
      </b-col>
      <b-col>
        <v-text-field
          v-model="tempGlobalPalletDoc.num"
          :label="$t('DOC_NUM')"
          hide-details
          type="number"
          step="1"
          min="0"
        ></v-text-field>
      </b-col>
      <b-col>
        <FormDatepickerBase
          :type="'text'"
          :i18n="{
            label: 'DOC_DATE',
            placeholder: $t('DOC_DATE')
          }"
          :date.sync="tempGlobalPalletDoc.date"
        ></FormDatepickerBase>
      </b-col>
      <b-col>
        <v-text-field
          v-model="tempGlobalPalletDoc.totalCurrency"
          :label="$t('TOTAL_PRICE')"
          hide-details
          type="number"
          step="1"
          min="0"
        ></v-text-field>
      </b-col>
      <b-col lg="1">
        <v-select
          hide-details
          :items="currencies"
          item-text="code"
          item-value="id"
          :label="$t('CURRENCY')"
          v-model="tempGlobalPalletDoc.currencyId"
        ></v-select>
      </b-col>
      <b-col lg="1">
        <v-select
          hide-details
          :items="vatGroups"
          item-text="name"
          item-value="id"
          :label="$t('VAT_GROUPS')"
          v-model="tempGlobalPalletDoc.vatGroupId"
        ></v-select>
      </b-col>
    </template>
  </b-row>
</template>
<script>
import FormDatepickerBase from "@/view/content/forms/components/FormDatepickerBase.vue";
import _ from "lodash";
export default {
  name: "SetPalletDoc",
  inheritAttrs: false,
  props: {
    supplierName: {
      type: String,
      default: function() {
        return "";
      }
    },
    firstLoader: {
      type: Boolean,
      default: true
    },
    vatGroups: {
      type: Array,
      default: function() {
        return [];
      }
    },
    currencies: {
      type: Array,
      default: function() {
        return [];
      }
    },
    globalPalletDoc: {
      type: Object,
      default: function() {
        return {
          visible: false,
          num: "",
          date: "",
          vatGroupId: 3,
          currencyId: 1,
          totalCurrency: "0.00"
        };
      }
    }
  },
  data() {
    return {};
  },
  components: { FormDatepickerBase },
  mounted() {},
  computed: {
    tempFirstLoader: {
      get: function() {
        return this.firstLoader;
      },
      set: function(newValue) {
        this.$emit("update:firstLoader", newValue);
      }
    },
    tempGlobalPalletDoc: {
      get: function() {
        return this.globalPalletDoc;
      },
      set: function(newValue) {
        this.$emit("update:globalPalletDoc", newValue);
      }
    }
  },
  watch: {},
  methods: {
    addService() {
      let vm = this;
      vm.tempGlobalPalletDoc.visible = true;
    },
    removeService() {
      let vm = this;
      vm.tempGlobalPalletDoc.visible = false;
    }
  }
};
</script>
